<template>
    <div :class="inputClass">
        <input
            v-bind="attrs"
            :value="prefill || value"
            :placeholder="placeholder"
            :autofocus="hasAutofocus"
            :required="isRequired"
            :type="type"
            :disabled="isDisabled"
            :max="maxDate"
            :min="minDate"
            :minlength="minlength"
            :maxlength="maxLength"
            @blur="emitEvent({ name: 'blur' })"
            @focus="emitEvent({ name: 'focus' })"
            @input="changeInput($event)"
        />
    </div>
</template>

<script>
    import FormInputMixin from 'mixins/FormInputMixin'

    export default {
        mixins: [FormInputMixin],

        props: {
            value: { type: [String, Number], default: undefined },
            prefill: { type: [String, Number], default: undefined },
            placeholder: { type: String, default: undefined },
            type: { type: String, default: 'text' },
            isSuggested: { type: Boolean, default: false },
            maxDate: { type: String, default: undefined },
            minDate: { type: String, default: undefined },
            maxLength: { type: Number, default: undefined },
            minlength: { type: Number, default: undefined },
            numericOnly: { type: Boolean, default: false },
        },

        computed: {
            inputClass() {
                return {
                    'form-input-text': true,
                    'form-input-text--is-invalid': this.isInvalid,
                    'form-input-text--is-disabled': this.isDisabled,
                    'form-input-text--is-prefilled': Boolean(this.prefill),
                    'form-input-text--is-suggested': this.isSuggested,
                }
            },
        },

        methods: {
            changeInput(event) {
                let value = event.target.value

                if (this.numericOnly) {
                    value = value.replace(/\D/g, '')
                    event.target.value = value
                }
                this.change(event)

                const inputSibling = event.target.parentElement.nextElementSibling
                if (
                    this.attrs &&
                    this.attrs.maxlength === event.target.value.length &&
                    inputSibling &&
                    inputSibling.firstElementChild
                ) {
                    inputSibling.firstElementChild.focus()
                }
            },
        },
    }
</script>
